module.exports = __webpack_public_path__ + "img/Troya-Logo.4ca08b62.png";